// Types
import type { ImageProps } from '@/types/components/atoms/items/image'

const ImageAtom = (props: ImageProps) => {
	// Props
	const { src, alt, width, height } = props

	return (
		<span className="editor-image">
			<picture>
				<img src={src} alt={alt} width={width} height={height} />
			</picture>
		</span>
	)
}

export default ImageAtom
